import { render, staticRenderFns } from "./SolicitacoesRemocao.vue?vue&type=template&id=104bf47a"
import script from "./SolicitacoesRemocao.vue?vue&type=script&lang=js"
export * from "./SolicitacoesRemocao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports